import { BadgePercent } from "lucide-react";
import { useDiscounts, fmtRate } from "@/lib/useDiscounts";

// Mention commerciale de la remise panachée, affichée sur les produits d'un viticulteur qui en propose
export default function DiscountNote({ producer, compact = false }) {
  const tiersMap = useDiscounts();
  const tiers = tiersMap[producer];
  if (!tiers || !tiers.length) return null;
  const text = `Remise panachée : ${tiers.map((t) => `${fmtRate(t.rate)} dès ${t.threshold} bt`).join(" · ")}`;
  if (compact) {
    return (
      <p className="text-[0.6rem] font-semibold text-[#8C6D23] mt-1 flex items-center gap-1" data-testid="discount-note">
        <BadgePercent size={11} className="shrink-0" /> {text}
      </p>
    );
  }
  return (
    <div className="mt-4 flex items-start gap-2.5 bg-[#F5EEDC] border border-[#C5A059]/40 rounded-2xl px-4 py-3" data-testid="discount-note">
      <BadgePercent size={17} className="text-[#8C6D23] shrink-0 mt-0.5" />
      <p className="text-xs text-[#1C1917] leading-relaxed">
        <span className="font-bold text-[#8C6D23]">Offre {producer}</span>
        <br />
        {text} — cumulable entre les vins de ce viticulteur.
      </p>
    </div>
  );
}
